import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const SERVICE_ID = 'service_a41p6sc';
const TEMPLATE_ID = 'template_oms8pfa';
const PUBLIC_KEY = 'v816-xGSh2DFwo2l1';

function Contact() {
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    topic: '',
    message: ''
  });

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init(PUBLIC_KEY);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    const templateParams = {
      to_name: 'Pure Paths',
      to_email: 'pathspure@gmail.com',
      from_name: formData.email,
      email: formData.email,
      topic: formData.topic,
      message: formData.message,
      subject: `Pure Paths Contact: ${formData.topic} - from ${formData.email}`
    };

    try {
      // Using direct API call instead of emailjs.send
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          service_id: SERVICE_ID,
          template_id: TEMPLATE_ID,
          user_id: PUBLIC_KEY,
          template_params: templateParams
        })
      });

      if (response.ok) {
        console.log('SUCCESS!');
        alert('Takk for din henvendelse! Vi vil kontakte deg snart.');
        setFormData({
          email: '',
          topic: '',
          message: ''
        });
      } else {
        const errorText = await response.text();
        throw new Error(errorText);
      }
    } catch (error) {
      console.error('Failed to send email:', error);
      alert('Kunne ikke sende melding. Vennligst prøv igjen senere.');
    } finally {
      setSending(false);
    }
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1>Kontakt Oss</h1>
        <p>Ta kontakt med oss for å lære mer om Pure Paths</p>
        
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="email">E-post:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Din e-postadresse"
              disabled={sending}
            />
          </div>

          <div className="form-group">
            <label htmlFor="topic">Emne:</label>
            <input
              type="text"
              id="topic"
              name="topic"
              value={formData.topic}
              onChange={handleChange}
              required
              placeholder="Hva gjelder henvendelsen?"
              disabled={sending}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Melding:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Skriv din melding her..."
              rows="5"
              disabled={sending}
            />
          </div>

          <button 
            type="submit" 
            className="submit-button"
            disabled={sending}
          >
            {sending ? 'Sender...' : 'Send Melding'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact; 